
export interface GalleryImage {
  id: string;
  src: string;
  alt: string;
  hint: string;
}

export interface GalleryEvent {
  id: string;
  title: string;
  date: string;
  modVersion: string;
  images: GalleryImage[];
}

export const galleryEvents: GalleryEvent[] = [
  {
    id: "magna-2-0",
    title: "Magna 'Testigos de la Esperanza'",
    date: "Septiembre 2025",
    modVersion: "2.0",
    images: Array.from({ length: 64 }, (_, i) => ({
      id: `magna-${i + 1}`,
      src: `/images/magna25/${i + 1}.webp`,
      alt: `Foto ${i + 1} de la Magna 'Testigos de la Esperanza'`,
      hint: 'religious procession night'
    }))
  },
  {
    id: "rocio-2025",
    title: "Rocío 2025",
    date: "Agosto 2025",
    modVersion: "2.0",
    images: Array.from({ length: 21 }, (_, i) => ({
      id: `rocio25-${i + 1}`,
      src: `/images/rocio25/${i + 1}.webp`,
      alt: `Foto ${i + 1} del Rocío 2025`,
      hint: 'pilgrimage flamenco'
    }))
  },
  {
    id: "coronacion-caridad",
    title: "Coronación Canónica Caridad y Consolación",
    date: "Julio 2025",
    modVersion: "2.0",
    images: Array.from({ length: 12 }, (_, i) => ({
      id: `coronacion-caridad-${i + 1}`,
      src: `/images/caridad/${i + 1}.webp`,
      alt: `Foto ${i + 1} de la coronación`,
      hint: 'virgin mary statue'
    }))
  },
  {
    id: "semana-santa-2025",
    title: "Semana Santa 2025",
    date: "Julio 2025",
    modVersion: "2.0",
    images: Array.from({ length: 95 }, (_, i) => ({
      id: `semana-santa-2025-${i + 1}`,
      src: `/images/ss25/${i + 1}.webp`,
      alt: `Foto ${i + 1} de la Semana Santa 2025`,
      hint: 'holy week procession'
    })),
  },
  {
    id: "via-crucis-2025",
    title: "Via Crucis del Consejo 2025",
    date: "Junio 2025",
    modVersion: "1.9",
    images: Array.from({ length: 10 }, (_, i) => ({
      id: `viacrucis25-${i + 1}`,
      src: `/images/vc25/${i + 1}.webp`,
      alt: `Foto ${i + 1} del Via Crucis 2025`,
      hint: 'night procession'
    }))
  },
  {
    id: "cuaresma-2025",
    title: "Cuaresma 2025",
    date: "Junio 2025",
    modVersion: "1.9",
    images: Array.from({ length: 11 }, (_, i) => ({
      id: `cuaresma25-${i + 1}`,
      src: `/images/cuaresma25/${i + 1}.webp`,
      alt: `Foto ${i + 1} de la Cuaresma 2025`,
      hint: 'church interior'
    }))
  },
  {
    id: "corpus-2024",
    title: "Corpus 2024",
    date: "Agosto 2024",
    modVersion: "1.8",
    images: Array.from({ length: 9 }, (_, i) => ({
      id: `corpus24-${i + 1}`,
      src: `/images/corpus24/${i + 1}.webp`,
      alt: `Foto ${i + 1} del Corpus 2024`,
      hint: 'religious festival'
    }))
  },
  {
    id: "rocio-2024",
    title: "Rocío 2024",
    date: "Agosto 2024",
    modVersion: "1.6",
    images: Array.from({ length: 12 }, (_, i) => ({
      id: `rocio24-${i + 1}`,
      src: `/images/rocio24/${i + 1}.webp`,
      alt: `Foto ${i + 1} del Rocío 2024`,
      hint: 'horse carriage pilgrimage'
    }))
  },
  {
    id: "coronacion-candelaria",
    title: "Coronación canónica Candelaria",
    date: "Julio 2024",
    modVersion: "1.6",
    images: Array.from({ length: 8 }, (_, i) => ({
      id: `coronacion-candelaria-${i + 1}`,
      src: `/images/candelaria/${i + 1}.webp`,
      alt: `Foto ${i + 1} de la coronación`,
      hint: 'virgin statue crown'
    }))
  },
  {
    id: "semana-santa-2024",
    title: "Semana Santa 2024",
    date: "Julio 2024",
    modVersion: "1.5",
    images: Array.from({ length: 27 }, (_, i) => ({
      id: `semana-santa-2024-${i + 1}`,
      src: `/images/ss24/${i + 1}.webp`,
      alt: `Foto ${i + 1} de la Semana Santa 2024`,
      hint: 'holy week parade'
    })),
  },
  {
    id: "via-crucis-2024",
    title: "Via Crucis del Consejo 2024",
    date: "Junio 2024",
    modVersion: "1.2",
    images: Array.from({ length: 9 }, (_, i) => ({
      id: `viacrucis24-${i + 1}`,
      src: `/images/vc24/${i + 1}.webp`,
      alt: `Foto ${i + 1} del Via Crucis 2024`,
      hint: 'cross procession'
    }))
  },
  {
    id: "cuaresma-2024",
    title: "Cuaresma 2024",
    date: "Junio 2024",
    modVersion: "1.2",
    images: Array.from({ length: 11 }, (_, i) => ({
      id: `cuaresma24-${i + 1}`,
      src: `/images/cuaresma24/${i + 1}.webp`,
      alt: `Foto ${i + 1} de la Cuaresma 2024`,
      hint: 'altar candles'
    }))
  },
];


export const hermandadesData = [
  // This data is now fetched dynamically, but kept here as a fallback or for reference.
  {
    id: 1,
    name: 'Hermandad del Huerto',
    shortName: 'Huerto',
    fundacion: 2023,
    sede: 'Parroquia de San Francisco',
    titulares: 'Ntro. Padre Jesús de la Oración en el Huerto y María Santísima de la Candelaria Coronada.',
    image: 'https://i.imgur.com/sgcr59C.png',
    image2: 'https://i.imgur.com/sFac8gM.png',
    shieldHint: 'cross gold',
    shieldImage: 'https://i.imgur.com/L9g2Qjg.png',
    numeroDeHermanos: 550,
    diaDeSalida: 'Jueves Santo',
  },
];

export const modUpdatesData = [
  {
    version: 'Mod Cofrade 1.0',
    date: 'Julio de 2023',
    description: [
      'Primera versión del mod cofrade.',
      'Se lanza el primer paso del mod, el crucificado.',
      'Se añade una cruz de guía básica de madera y la moneda oficial del servidor, los jartis.',
    ],
    images: ['/images/modcofrade/1.webp'],
  },
  {
    version: 'Mod Cofrade 1.2',
    date: 'Diciembre de 2023',
    description: [
      'Se añaden más de 15 pasos nuevos.',
      'Se añaden todo tipo de enseres.',
      'Se añaden las imágenes de retablo.',
    ],
    images: ['/images/modcofrade/12.webp'],
  },
  {
    version: 'Mod Cofrade 1.5',
    date: 'Junio de 2024',
    description: [
      'Se añaden los pasos de palio con su respectivo movimiento de la estructura del palio.',
      'Se añade iluminación a los candelabros y candelería de todos los pasos.',
      'Se añaden las túnicas de acólitos y nazarenos.',
    ],
    images: ['/images/modcofrade/15.webp'],
  },
  {
    version: 'Mod Cofrade 1.8',
    date: 'Septiembre de 2024',
    description: [
      'Se añade la función "levantá".',
      'Se añaden las imágenes de retablo marianas.',
      'Se añade la custodia con su respectivo paso procesional.',
      'Se añaden nuevos enseres.',
    ],
    images: ['/images/modcofrade/18.webp'],
  },
  {
    version: 'Mod Cofrade 2.0',
    date: 'Junio de 2025',
    description: [
      'Se reforman por completo todos los pasos del mod.',
      'Se añaden nuevos pasos.',
      'Se añade nueva función de jugabilidad con todo tipo de movimientos y controles realistas a los pasos para una mayor inmersión y realismo.',
      'Se añaden cortejos funcionales que permiten embellecer la puesta en escena de las procesiones con largas filas de penitentes.',
      'Se añade el público.',
      'Se añaden bandas funcionales, dando mayor inmersión y un nuevo rol para los jugadores del servidor pudiendo crear sus bandas y gestionarlas.',
      'Se reforman la gran mayoría de enseres para darle mas realismo.',
    ],
    images: [
      '/images/ss25/44.webp',
      '/images/magna25/41.webp',
      '/images/magna25/55.webp',
      '/images/ss25/62.webp',
    ],
  },
  {
    version: 'Mod Cofrade 3.0',
    date: 'Julio de 2026',
    description: [
      'La actualización más ambiciosa hasta la fecha del Mod Cofrade. Ya es una realidad.',
      'Cifrado completo del mod y sistemas antirrobo para evitar graciosillos 😏...',
      'Cortejos y Bandas mejorados a otro nivel nunca visto, permitiendo miles, sí, ¡miles!, de nazarenos por las calles de nuestra ciudad.',
      'Nuevo sistema de optimización de primer nivel.',
      'Capirotes y túnicas con formas y texturas realistas.',
      'Cirios, ciriales y faroles con llamas reales animadas y que iluminan.',
      'Candelería realista para los pasos con sistema de fundición de velas.',
      'Sistema avanzado y complejo de montaje de pasos nunca visto.',
      'Andar realista de los costaleros bajo el paso y movimiento realista del paso.',
      'Físicas realistas para el movimiento de las estructuras de palio y faldones.',
      'Puertas de iglesias funcionales e interactivas.',
      'Petalás realistas con efecto viento, permitiendo que se acumulen pétalos en los techos de palio.',
      'Y MUCHO MÁS.',
    ],
    // Mismas fotos que rotan de fondo en la portada: son capturas de 3.0.
    images: [
      '/images/hero/hero-1.webp',
      '/images/hero/hero-2.webp',
      '/images/hero/hero-3.webp',
      '/images/hero/hero-4.webp',
    ],
    /** Se saca del timeline y se muestra como lanzamiento destacado arriba del todo. */
    featured: true,
  },
];


export const mapLocations = [
    {
        id: 1,
        name: 'La Capital',
        description: 'El corazón bullicioso de Jartiland.',
        top: '45.5%',
        left: '49%',
    },
    {
        id: 2,
        name: 'Bosque Sombrío',
        description: 'Un bosque antiguo y misterioso.',
        top: '25%',
        left: '19.5%',
    },
    {
        id: 3,
        name: 'Montañas del Eco',
        description: 'Picos imponentes y solitarios.',
        top: '21%',
        left: '79%',
    },
    {
        id: 4,
        name: 'Puerto Salado',
        description: 'Una ciudad costera vibrante.',
        top: '80%',
        left: '64%',
    },
    {
        id: 5,
        name: 'Las Ruinas Olvidadas',
        description: 'Restos de una civilización antigua.',
        top: '73.5%',
        left: '28.5%',
    },
    {
        id: 6,
        name: 'Lugar Misterioso',
        description: 'Describe este lugar.',
        top: '58%',
        left: '79%',
    },
    {
        id: 7,
        name: 'Lugar Misterioso',
        description: 'Describe este lugar.',
        top: '40%',
        left: '30%',
    },
    {
        id: 8,
        name: 'Lugar Misterioso',
        description: 'Describe este lugar.',
        top: '44%',
        left: '64%',
    },
    {
        id: 9,
        name: 'Lugar Misterioso',
        description: 'Describe este lugar.',
        top: '65%',
        left: '52%',
    },
     {
        id: 10,
        name: 'Lugar Misterioso',
        description: 'Describe este lugar.',
        top: '85%',
        left: '43%',
    },
];

export const cityLocationsData = [
  {
    id: 'plaza-mayor',
    name: 'Plaza Mayor',
    description: 'El corazón palpitante de la ciudad, donde se celebran los mercados, los anuncios importantes y los festivales. Es el principal punto de encuentro para todos los ciudadanos y un hervidero de actividad a todas horas.',
    thumbnail: 'https://picsum.photos/400/300?random=plaza',
    hint: 'town square medieval',
    images: [
      { id: 1, src: 'https://picsum.photos/800/600?random=plaza1', alt: 'Vista diurna de la Plaza Mayor', hint: 'medieval square day' },
      { id: 2, src: 'https://picsum.photos/800/600?random=plaza2', alt: 'Mercado en la Plaza Mayor', hint: 'medieval market' },
      { id: 3, src: 'https://picsum.photos/800/600?random=plaza3', alt: 'Festival nocturno en la plaza', hint: 'night festival lights' },
    ]
  },
  {
    id: 'catedral',
    name: 'La Gran Catedral',
    description: 'Imponente y majestuosa, la Gran Catedral es el centro espiritual de Jartiland. Sus altas agujas se pueden ver desde casi cualquier punto de la ciudad y su interior es un remanso de paz y arte sacro.',
    thumbnail: 'https://picsum.photos/400/300?random=cathedral',
    hint: 'gothic cathedral',
    images: [
      { id: 1, src: 'https://picsum.photos/800/600?random=cathedral1', alt: 'Exterior de la Gran Catedral', hint: 'cathedral facade' },
      { id: 2, src: 'https://picsum.photos/800/600?random=cathedral2', alt: 'Interior de la nave principal', hint: 'cathedral interior' },
      { id: 3, src: 'https://picsum.photos/800/600?random=cathedral3', alt: 'Vidrieras de la Catedral', hint: 'stained glass' },
    ]
  },
  {
    id: 'ayuntamiento',
    name: 'Ayuntamiento',
    description: 'Sede del gobierno de la ciudad y lugar donde se toman las decisiones más importantes. El edificio es un ejemplo de la arquitectura cívica, con una torre del reloj que marca el ritmo de la vida urbana.',
    thumbnail: 'https://picsum.photos/400/300?random=townhall',
    hint: 'medieval town hall',
    images: [
      { id: 1, src: 'https://picsum.photos/800/600?random=townhall1', alt: 'Fachada del Ayuntamiento', hint: 'town hall exterior' },
      { id: 2, src: 'https://picsum.photos/800/600?random=townhall2', alt: 'Salón de Plenos', hint: 'throne room' },
      { id: 3, src: 'https://picsum.photos/800/600?random=townhall3', alt: 'Detalle de la torre del reloj', hint: 'clock tower' },
    ]
  },
    {
    id: 'murallas',
    name: 'Las Murallas',
    description: 'Las imponentes murallas de piedra que protegen la ciudad. Ofrecen unas vistas espectaculares y son el testimonio de la fuerza y la historia de Jartiland. Recorrer el adarve es una experiencia única.',
    thumbnail: 'https://picsum.photos/400/300?random=walls',
    hint: 'castle walls',
    images: [
      { id: 1, src: 'https://picsum.photos/800/600?random=walls1', alt: 'Vista de las murallas al atardecer', hint: 'city walls sunset' },
      { id: 2, src: 'https://picsum.photos/800/600?random=walls2', alt: 'Torreón de vigilancia', hint: 'castle tower' },
      { id: 3, src: 'https://picsum.photos/800/600?random=walls3', alt: 'Paseo por el adarve', hint: 'castle rampart' },
    ]
  },
];
